import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
class Footer {

    constructor() {
        this._init();
    }


    private _init(): void {
        new Swiper('.footer__partenaires-swiper', {
            modules: [Autoplay],
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 20,
            grabCursor: true,
            mousewheel: true,
            preventInteractionOnTransition: true,
            freeMode: true,
            loop: true,
            speed: 4000,
            autoplay: {
                delay: 500,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    spaceBetween: 24,
                    autoplay: false,
                    loop: false
                },
                1025: {
                    spaceBetween: 40
                }
            }
        });

    }

}

export const footer = new Footer();
